var map = {
	"./ice_cold_shot_green.png": "ca45",
	"./ice_cold_shot_greenOLD1.png": "f866",
	"./ice_cold_shot_green_start.png": "eadd",
	"./ice_cold_shot_white.png": "7b4a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4b00";